module.exports = __webpack_public_path__ + "img/balloons.2b41f1bc.svg";